import { useEffect, useState } from 'react'
import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { useMutation } from '@tanstack/react-query'
import { signInTenantUser } from '@/api/settings/tenant-setting.js'
import { viewAsModeGuard } from '@/utils/auth.js'

export const Route = createFileRoute('/view-as-mode')({
  beforeLoad: viewAsModeGuard,
  component: ViewAsMode,
})

function ViewAsMode() {
  const [redirect, setRedirect] = useState(false)
  const [userData, setUserData] = useState(null)
  const [error, setError] = useState(null)
  const urlSearchParams = useSearch({})

  const getTokenForSpyMode = useMutation({
    mutationFn: async ({ email, tenantId }) => {
      const { data, error } = await signInTenantUser({
        tenantId,
        data: { email },
      })
      if (error) {
        console.error('ViewAsMode: Lỗi khi đăng nhập chuyên viên', { error })
        setError(error.message || 'Đã xảy ra lỗi khi đăng nhập chuyên viên')
        return null
      }
      return data
    },
    onSuccess: (data) => {
      console.log('ViewAsMode: Đăng nhập thành công', { data })
      const { token, info } = data || {}
      setUserData(data)
      sessionStorage.setItem(
        'viewAsUserData',
        JSON.stringify({ ...info, token }),
      )
      setRedirect(true)
    },
    onError: (error) => {
      console.error('ViewAsMode: Đăng nhập thất bại', { error })
      setError(error.message || 'Đã xảy ra lỗi khi đăng nhập chuyên viên')
    },
  })

  useEffect(() => {
    const email = urlSearchParams?.email
    const tenantId = urlSearchParams?.tenantId
    if (!email || !tenantId) {
      setError('Thiếu thông tin email hoặc tenantId trong URL')
      return
    }
    console.log('ViewAsMode: Bắt đầu đăng nhập chuyên viên', {
      email,
      tenantId,
    })
    getTokenForSpyMode.mutate({ email, tenantId })
  }, [])

  // Redirect về trang chủ sau khi xử lý xong và chờ 3s
  if (redirect) {
    console.log('ViewAsMode: Đang chuyển hướng về trang chủ...')
    return <Navigate to="/" />
  }

  // Hiển thị màn hình loading trong 3 giây
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4 text-center">
        <Loader2 className="h-16 w-16 animate-spin text-primary" />
        <h2 className="text-2xl font-medium">
          {error
            ? 'Đã xảy ra lỗi'
            : userData
              ? `Đang kích hoạt chế độ giám sát cho ${userData.info?.name || ''}...`
              : 'Đang kích hoạt chế độ giám sát...'}
        </h2>
        <p className="text-muted-foreground">
          {error ? error : 'Vui lòng chờ trong giây lát...'}
        </p>
        <div className="mt-2 text-sm text-muted-foreground">
          <CountDownTitle seconds={3} />
        </div>
      </div>
    </div>
  )
}

function CountDownTitle({ seconds }) {
  const [timeLeft, setTimeLeft] = useState(seconds)
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])
  return (
    <div className="text-lg font-medium">
      Tự động chuyển hướng sau {timeLeft} giây ...
    </div>
  )
}
